module.exports = __webpack_public_path__ + "static/monkey-5a8d75e1f941fdd2e01ecc2a95cdb96f.svg";